import '~/sentry';

import { registerControllers } from 'vite-plugin-symfony/stimulus/helpers';

import loadStimulusApp from '~/stimulus-app';

const app = loadStimulusApp();

registerControllers(
    app,
    import.meta.glob('./javascript/controllers/**/*-controller.js', {
        query: '?stimulus',
        /**
         * always true, the `lazy` behavior is managed internally with
         * import.meta.stimulusFetch (see reference)
         */
        eager: true,
    }),
);
